import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";
import { connect } from 'react-redux';
import helper from 'utils/helpers'
import { get } from 'services';
import PhoneTemplate from './phoneTemplate';
import DniTemplate from './dniTemplate';
import Alerts from 'utils/alerts' 
import Spinner from 'react-bootstrap/Spinner';

const capitalize = {
    textTransform: 'capitalize'
}

const mt15 = {
    marginTop: 5
}

const isBrowserMt = isBrowser ? mt15 : null;
const isBrowserCol12 = isBrowser ? 6 : 12;

const formatPhoneNumber = (phone) => {
    if (phone.length == 10) { 
        return `(${phone.substring(0,3)}) ${phone.substring(3,6)}-${phone.substring(6,10)}`
    } else {
        return phone
    }
}

const lastNameFormat = (first, second) => {
    if (first && second) {
        return `${first} ${second}`
    } else if (first) {
        return first;
    }  else {
        return second;
    } 
}
 
const UserDetail = ({ user }) => {
    const [phoneTypes, setPhoneTypes] = useState([]);
    //const [dniTypes, setDniTypes] = useState([]);
    const [region, setRegion] = useState('No especificado');
    const [provincia, setProvincia] = useState('No especificado');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        (async function mounted() {
            try {
                setIsLoading(true)
                get('TelefonoTipo').then(response => {
                    setPhoneTypes(response.data)
                })
                if (user.persona && user.persona.ciudadId) {
                    const ciudad = await get(`Ciudad?$filter=Id eq ${user.persona.ciudadId}`);
                    const prov = await get(`Provincia?$filter=Id eq ${ciudad.data[0].provinciaId}`);
                    const rgn = await get(`Region?$filter=Id eq ${prov.data[0].regionId}`);
                    setProvincia(prov.data[0].nombre)
                    setRegion(rgn.data[0].nombre)
                }
            } catch (error) {
            } finally {
                setIsLoading(false)
            }
        })();
        return function cleanup() {
            //setDniTypes([]);
            setPhoneTypes([]);
        };
    }, [])

    return (
        <>
            {
                isLoading &&
                <div className={'display-flex flex-direction-row flex-center'}>
                    <Spinner 
                        animation="grow" 
                        variant="primary" 
                        className={'is-absolute center-spinner-vertically'} 
                        size="lg" />
                </div>
            }
            <Card>
                <Card.Body className={'p-30'}>
                    <Row>
                        <Col xs={isBrowserCol12}>
                            <Row>
                                <Col xs={isBrowserCol12}>
                                    <strong> Nombres </strong>
                                </Col>
                                <Col xs={isBrowserCol12}>
                                    <span style={capitalize}>
                                        {
                                            user.persona.nombre 
                                                ? user.persona.nombre
                                                : 'No especificado' 
                                        }
                                    </span>
                                    
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Primer apellido </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    <span style={capitalize}>
                                        {
                                            user.persona.primerApellido 
                                                ? user.persona.primerApellido
                                                : 'No especificado' 
                                        }
                                    </span>
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Segundo apellido </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    <span style={capitalize}>
                                        {
                                            user.persona.segundoApellido
                                                ? user.persona.segundoApellido
                                                : 'No especificado' 
                                        }
                                    </span>
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Tipo de sangre </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {
                                        user.persona.tipoSangreUI
                                            ? user.persona.tipoSangreUI
                                            : 'No especificado' 
                                    }
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Estado civil </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {
                                        user.persona.estadoCivilUI
                                            ? user.persona.estadoCivilUI
                                            : 'No especificado' 
                                    }
                                </Col>

                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Fecha de nacimiento </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    { 
                                        user.persona.fechaNacimiento && helper.convertDate(user.persona.fechaNacimiento) != '01/01/0001'
                                            ? helper.convertDate(user.persona.fechaNacimiento)
                                            : 'No especificado' 
                                    }
                                </Col>
                                
                                { 
                                    user.esEmpleado &&
                                    <>
                                        <Col style={mt15} xs={isBrowserCol12}>
                                            <strong> Fecha de cumpleaños </strong>
                                        </Col>
                                        <Col style={isBrowserMt} xs={isBrowserCol12}>
                                            { 
                                                user.persona.fechaCumpleanios && helper.convertDate(user.persona.fechaCumpleanios) != '01/01/0001'
                                                    ? helper.convertDate(user.persona.fechaCumpleanios)
                                                    : 'No especificado' 
                                            }
                                        </Col>
                                    </>
                                }
                                
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Lugar de nacimiento </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {
                                        user.persona.lugarNacimiento 
                                            ? user.persona.lugarNacimiento
                                            : 'No especificado' 
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={isBrowserCol12}>
                            <Row>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> País </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {
                                        user.persona.paisUI 
                                            ? user.persona.paisUI
                                            : 'No especificado' 
                                    }
                                </Col>
                                <Col style={!isBrowser ? mt15 : null} xs={isBrowserCol12}> 
                                    <strong> Región </strong>
                                </Col>
                                <Col xs={isBrowserCol12}>
                                    {
                                        region
                                    }
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Ciudad </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {
                                        user.persona.ciudadUI 
                                            ? user.persona.ciudadUI
                                            : 'No especificado' 
                                    }
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Correo electrónico </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {
                                        user.persona.email 
                                            ? user.persona.email
                                            : 'No especificado' 
                                    }
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Correo alternativo </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {
                                        user.persona.emailAlternativo 
                                            ? user.persona.emailAlternativo
                                            : 'No especificado' 
                                    }
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Dirección </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {
                                        user.persona.direccion 
                                            ? user.persona.direccion
                                            : 'No especificado' 
                                    }
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Licencia </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    { user.persona.licenciaConducir &&  user.persona.licenciaConducir != 0 ? 'Sí' : 'No'}
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Tiene vehículo </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    { user.persona.tieneVehiculo &&  user.persona.tieneVehiculo != 0 ? 'Sí' : 'No'}
                                </Col>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Contacto de emergencia </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {

                                        user.persona.telefonoContacto 
                                            ? formatPhoneNumber(user.persona.telefonoContacto)  
                                            : 'No especificado' 
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    
                    {
                        (user && user.esEmpleado) && <Row>
                            <Col xs={isBrowserCol12}>
                                <Row>
                                    <Col style={mt15} xs={isBrowserCol12}>
                                        <strong> Size camisa </strong>
                                    </Col>
                                    <Col style={isBrowserMt} xs={isBrowserCol12}>
                                        {
                                            user.persona.sizeCamisa 
                                                ? user.persona.sizeCamisa
                                                : 'No especificado' 
                                        }
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={isBrowserCol12}>
                                <Row>
                                    <Col style={mt15} xs={isBrowserCol12}>
                                        <strong> Size pantalón </strong>
                                    </Col>
                                    <Col style={isBrowserMt} xs={isBrowserCol12}>
                                        {
                                            user.persona.sizePantalon 
                                                ? user.persona.sizePantalon
                                                : 'No especificado' 
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    }

                    <Row>
                        <Col xs={isBrowserCol12}>
                            <Row>
                                {
                                    (user.persona && user.persona.personaTelefonos && user.persona.personaTelefonos.length > 0) &&
                                    <>
                                        {
                                            user.persona.personaTelefonos.filter(x => x && x.estado == 1).map((telefono) => {
                                                return <PhoneTemplate key={telefono.id} mt15={mt15} isBrowserCol12={isBrowserCol12} telefono={telefono} phoneTypes={phoneTypes} isBrowserMt={isBrowserMt}/>
                                            })
                                        }
                                    </>
                                }
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={isBrowserCol12}>
                            <Row>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Discapacidad </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {
                                        (user.persona.personaDiscapacidades.length > 0) 
                                        ? user.persona.personaDiscapacidades.find(x => x.estado == 1)?.descripcion 
                                        : 'N/A'
                                    }
                                </Col>
                            </Row>      
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={isBrowserCol12}>
                            <Row>
                                <Col style={mt15} xs={isBrowserCol12}>
                                    <strong> Aparato </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowserCol12}>
                                    {
                                        (user.persona.personaAparatos.length > 0) 
                                        ? user.persona.personaAparatos.find(x => x.estado == 1)?.descripcion 
                                        : 'N/A'
                                    }
                                </Col>
                            </Row>      
                        </Col>
                    </Row>
                    
                </Card.Body>
            </Card>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(UserDetail);